var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#36ff1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#19d700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#15aa00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#108000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(-1245 492)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(1245 -492)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/green.f5d30cf70f7938a923e8fbf682c6ccb3.svg";
export { ForwardRef as ReactComponent };